const MAX_LOADS_CACHE_KEY = 'MAX_LOADS_CACHE';

const initialLoadsCache = {};

export const resetLoadsCache = () => {
  try {
    localStorage.removeItem(MAX_LOADS_CACHE_KEY);
    const initialCacheJSON = JSON.stringify(initialLoadsCache);
    localStorage.setItem(MAX_LOADS_CACHE_KEY, initialCacheJSON);
  } catch (e) {
    console.error('LOCAL STORAGE ERROR resetCache');
  }
};

const getMaxLoadsCache = () => {
  let cache = initialLoadsCache;
  try {
    const cacheJSON = localStorage.getItem(MAX_LOADS_CACHE_KEY);
    if (!!cacheJSON) {
      cache = JSON.parse(cacheJSON);
    }
  } catch (e) {
    console.error('LOCAL STORAGE ERROR getMaxLoadsCache');
  }
  return cache;
};

export const getMaxLoadsRequestFromCache = (requestKey) => {
  const cache = getMaxLoadsCache();
  if (cache.hasOwnProperty(requestKey)) return cache[requestKey];
  return null;
};

export const saveMaxLoadsRequestToCache = (requestKey, data) => {
  const cache = getMaxLoadsCache();
  cache[requestKey] = data;
  try {
    const cacheJSON = JSON.stringify(cache);
    localStorage.setItem(MAX_LOADS_CACHE_KEY, cacheJSON);
  } catch (e) {
    console.error('LOCAL STORAGE ERROR saveMaxLoadRequestToCache');
  }
};
